import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "license-warning-banner"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_ctx.showBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createElementVNode("span", null, _toDisplayString(_ctx.bannerMessage), 1 /* TEXT */),
            _cache[5] || (_cache[5] = _createTextVNode()),
            (_ctx.canAccessAboutPage)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'about' },
                    class: "ms-2 banner-link"
                }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("View License", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _cache[6] || (_cache[6] = _createTextVNode()),
            _createElementVNode("button", {
                type: "button",
                class: "banner-close",
                "aria-label": "Dismiss license warning",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
            }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */)
                ]))])
        ]))
        : _createCommentVNode("v-if", true);
}
